var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-print-insertion-order-document"}},[_c('supplier-insertion-order-document-query',{attrs:{"id":_vm.$route.params.id,"supplier-id":_vm.$route.params.supplier_id},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isLoading = ref.isLoading;
var data = ref.data;
return [_c('div',[_c('insertion-order-document',{attrs:{"order":data && data.supplier.order,"supplier":data && data.supplier,"loading":isLoading}})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }